import clsx from 'clsx'
import React, { memo } from 'react'
import ImageHeart from '../../images/heart2.webp'
import './index.scss'

interface GiftProps {
  big?: boolean
  pic: string
  level: number
}

function Gift(props: GiftProps) {
  return <div className={clsx('cmp-gift', {
    big: props.big || false
  })}>
    <img src={props.pic} />
    <div className='cmp-gift__level'>
      <img src={ImageHeart} />LV{props.level}
    </div>
  </div>
}

export default memo(Gift)